// utils/handleResponseCode.js
export default function handleResponseCode(status, fallbackError) {
  if (!status) return fallbackError || "Nieznany błąd.";

  switch (status) {
    case 400:
      return "Nieprawidłowe dane wejściowe.";
    case 401:
      return "Brak autoryzacji. Zaloguj się ponownie.";
    case 403:
      return "Brak uprawnień do wykonania tej operacji.";
    case 404:
      return "Nie znaleziono zasobu.";
    case 409:
      return "Konflikt danych. Rekord już istnieje.";
    case 413:
      return "Plik jest zbyt duży.";
    case 415:
      return "Nieobsługiwany format pliku.";
    case 422:
      return "Błąd walidacji danych.";
    case 429:
      return "Zbyt wiele żądań. Spróbuj ponownie później.";
    case 500:
      return "Błąd serwera. Spróbuj ponownie za chwilę.";
    case 502:
    case 503:
    case 504:
      return "Serwis chwilowo niedostępny.";
    default:
      return fallbackError || "Wystąpił nieoczekiwany błąd.";
  }
}
